import List from "../../containers/Deals/List";
import Entry from "../../containers/Deals";

import excursionList from '../../containers/Excursions/List';
import excursionEntry from '../../containers/Excursions';

const dealRoutes = [
  {
    path: "/deals",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/deals/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/deals/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/excursions",
    exact: true,
    auth: true,
    component: excursionList
  },
  {
    path: "/excursions/:type",
    exact: true,
    auth: true,
    component: excursionEntry
  },
  {
    path: "/excursions/:type/:id",
    exact: true,
    auth: true,
    component: excursionEntry
  },
];

export default dealRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/deals.jsx